module.exports = __webpack_public_path__ + "static/media/bluePrint.53361df3.svg";